const API_URL = process.env.REACT_APP_CARDS;

export async function updateNode(authFetch, nodeId, fields) {
  try {
    const response = await authFetch(`${API_URL}${nodeId}/`, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(fields),
    });

    if (!response.ok) {
      const text = await response.text();
      throw new Error(`Failed to update node: ${text}`);
    }

    return response.json();
  } catch (error) {
    console.error('updateNode error:', error);
    throw error;
  }
}
